// Round is not ready for this funnel: wallets take payment with no email and Apple Pay fails outright.
export default {
  chargebeeOnly: true,
  growthbookEnabled: false,
};
